export default __webpack_public_path__ + "static/media/geisha.c93ca729.png";